import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
    Card,
    CardContent,
    Grid,
    IconButton,
    TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "@mui/icons-material/Create";
import { withRouter } from "react-router";
import {tagResources, validacionTagResources} from "../endpoints";
import DialogEditarCantidadValidacionTag from "./DialogEditarCantidadValidacionTag";

class TablaTagsValidados extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags_contados: null,
            tags_validados: null,
            porcentaje_validados: null,
            datos: [],
            datosFiltrados: [],
            tag: null,
            cantidad_val: null,
            cantidad_inv: null,
            editar: false,
            cargando: false,
            selectedRow: null,
            searchText: "",
        };
    }

    refrescar = (estado, severity) => {
        this.setState({ editar: false });
        this.props.refrescar(estado, severity);
        this.consultarTagsValidados();
    };

    handleClose = () => {
        this.setState({ editar: false });
    };

    consultarTagsValidados = () => {
        let tipo = this.props.tipo;
        this.setState({ cargando: true });
        tagResources
            .getValidacionTag(tipo)
            .then(async (response) => {
                if (response) {
                    return await response.json();
                }
            })
            .then((data) => {
                if (data.status_code === 200) {
                    const rows = data.consulta.map((row, index) => ({
                        ...row,
                        id: row.id ?? index,
                    }));
                    this.setState({
                        datos: rows,
                        datosFiltrados: rows,
                        cargando: false,
                    });
                } else if (data.status_code === 401) {
                    this.setState({
                        openSnack: true,
                        severity: data.severity,
                        message: data.message,
                    });
                } else {
                    throw new Error("Something went wrong ...");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    verDetalleTag = (row) => {
        if (row) {
            this.props.history.push("/detalles_tag/" + row.id);
        }
    };

    editarCantidadValidada = (row) => {
        this.setState({
            editar: true,
            cantidad_val: row.cant_val,
            tag: row.id,
            cantidad_inv: row.cant_inv,
        });
    };

    obtenerTotales = () => {
        validacionTagResources
            .getTotales('tags')
            .then(async (response) => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error("Something went wrong ...");
                }
            })
            .then((data) => {
                this.setState({
                    tags_contados: new Intl.NumberFormat("de-DE").format(
                        data.tags_contados
                    ),
                    tags_validados: new Intl.NumberFormat("de-DE").format(
                        data.tags_validados
                    ),
                    porcentaje_validados: (data.porcentaje_val * 100).toFixed(2),
                });
            })
            .catch((error) => {
                console.error(error);
            });
        this.consultarTagsValidados();
    };

    componentDidMount() {
        this.obtenerTotales();
    }

    handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        const filtrados = this.state.datos.filter((row) =>
            Object.values(row).some(
                (val) => val && val.toString().toLowerCase().includes(value)
            )
        );
        this.setState({ searchText: value, datosFiltrados: filtrados });
    };

    render() {
        const columns = [
            { field: "id", headerName: "Tag",flex: 1, minWidth: 120,},
            {
                field: "cant_inv",
                headerName: "Cantidad INV.",
                flex: 1, minWidth: 120,
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            {
                field: "cant_val",
                headerName: "Cantidad VAL.",
                flex: 1, minWidth: 120,
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            {
                field: "dif",
                headerName: "Diferencia",
                flex: 1, minWidth: 120,
                valueFormatter: (params) =>
                    new Intl.NumberFormat("de-DE").format(params.value),
            },
            { field: "validador", headerName: "Cod. Validador", flex: 1, minWidth: 120,},
            {
                field: "acciones",
                headerName: "Acciones",
                flex: 1, minWidth: 120,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                    <>
                        <IconButton
                            title="Ver tag"
                            onClick={() => this.verDetalleTag(params.row)}
                        >
                            <SearchIcon />
                        </IconButton>
                        <IconButton
                            title="Editar cantidad validada"
                            onClick={() => this.editarCantidadValidada(params.row)}
                        >
                            <CreateIcon />
                        </IconButton>
                    </>
                ),
            },
        ];

        return (
            <div>
                <Card style={{ background: "#dbe9fc" }}>
                    <CardContent>
                        <Grid container spacing={4} alignItems={"center"} justifyContent={"center"}>
                            <Grid item>
                                <b>Total Tags Inv.: </b>
                                {this.state.tags_contados}
                            </Grid>
                            <Grid item>
                                <b>Total tags Val.: </b>
                                {this.state.tags_validados}
                            </Grid>
                            <Grid item>
                                <b>Validación (%): </b>
                                {this.state.porcentaje_validados}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <br />
                <TextField
                    placeholder="Buscar"
                    variant="outlined"
                    size="small"
                    value={this.state.searchText}
                    onChange={this.handleSearch}
                    style={{ marginBottom: 10 }}
                />
                <div style={{ height: 600, width: "100%" }}>
                    <DataGrid
                        disableColumnMenu
                        disableColumnResize={true}
                        rows={this.state.datosFiltrados}
                        columns={columns}
                        loading={this.state.cargando}
                        onRowClick={(params) =>
                            this.setState({ selectedRow: params.id })
                        }
                        getRowClassName={(params) =>
                            this.state.selectedRow === params.id ? "row-selected" : ""
                        }
                        pageSizeOptions={[10, 30, 50]}
                        getRowHeight={() => 'auto'}
                        initialState={{
                            pagination: {
                                paginationModel: {pageSize: 30, page: 0},
                            },
                        }}
                    />
                </div>
                {this.state.editar && (
                    <DialogEditarCantidadValidacionTag
                        refrescar={this.refrescar}
                        tag={this.state.tag}
                        tipo ='tags'
                        cantidad_actual={this.state.cantidad_val}
                        cantidad_inv={this.state.cantidad_inv}
                        handleClose={this.handleClose}
                        codigo ={null}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(TablaTagsValidados);
